/**
 * Created by Karol Kluska on 11.01.18.
 */
angular
  .module('app')
  .value('parentIframeData', {
    enable: false,
    scrollTop: 0,
    offsetTop: 0
  });
